import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'
import { EFIconProps } from './IconProps'

export function ConfigIcon(propsIcon: EFIconProps) {
  const isDark = useAppSelector(isDarkTheme)
  const fill = isDark ? 'var(--color-dark-theme)' : 'var(--icon-color-light-theme)'

  return (
    <svg
      width='34'
      height='35'
      viewBox='0 0 34 35'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_11_11279)'>
        <path
          d='M30.5977 23.4789L23.1482 16.8571H21.7567L18.1866 20.0306V21.2675L25.6361 27.8892C26.1842 28.3765 27.0697 28.3765 27.6179 27.8892L30.5977 25.2405C31.1459 24.7657 31.1459 23.9661 30.5977 23.4789ZM26.62 25.253L20.6604 19.9556L21.6583 19.0685L27.6179 24.3659L26.62 25.253Z'
          fill={fill}
        />
        <path
          d='M24.5115 13.5087L26.4934 11.7471L29.4732 14.3958C31.1177 12.934 31.1177 10.5602 29.4732 9.09839L24.4975 4.67555L22.5156 6.43719V2.91391L21.5317 2.02684L16.5561 6.44968L17.554 7.33675H21.5317L19.5499 9.09839L21.0398 10.4227L16.9777 14.0335L11.1727 8.8735V7.09937L6.92794 3.32621L2.9502 6.86198L7.20905 10.6476H9.1909L14.9959 15.8076L13.8011 16.8696H10.8214L3.37186 23.4914C2.82369 23.9786 2.82369 24.7657 3.37186 25.253L6.35166 27.9017C6.89983 28.389 7.78533 28.389 8.3335 27.9017L15.783 21.2799V18.6312L23.0216 12.1969L24.5115 13.5087ZM13.2951 19.9431L7.33555 25.2405L6.3376 24.3534L12.2972 19.056L13.2951 19.9431Z'
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id='clip0_11_11279'>
          <rect
            width='33.7335'
            height='33.7335'
            fill='white'
            transform='translate(0.139099 0.77746)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
